export const createReducer = (actionCreator, action, reducers) => {
    reducers[actionCreator.getType()] = action;
};
